/**
 * @fileoverview A linha digitável do boleto como o banco imprime (31/10/2026,
 * etapa 7 dos planos): a Pagar.me manda os 47 números juntos; na tela, em
 * blocos (AAAAA.AAAAA BBBBB.BBBBBB CCCCC.CCCCCC D EEEEEEEEEEEEEE). Para copiar,
 * só os números (o app do banco aceita assim).
 */

export const boletoDigits = (line) => (line || "").replace(/\D/g, "");

export const formatBoletoLine = (line) => {
  const digits = boletoDigits(line);
  if (digits.length !== 47) return line || "";
  return `${digits.slice(0, 5)}.${digits.slice(5, 10)} ${digits.slice(10, 15)}.${digits.slice(15, 21)} ${digits.slice(21, 26)}.${digits.slice(26, 32)} ${digits.slice(32, 33)} ${digits.slice(33)}`;
};
